import {jwtServerInstance} from "../index";
import qs from	'qs'

export const getAllExpressType = () =>{
    return jwtServerInstance.request({
        url:'/b2cexpresstype/all',
        method:'post'
    });
}

export const queryKuaidiList = () => {
    return jwtServerInstance.request({
        url:'/b2cexpressmsg/querykuaidilist',
        method:'post'
    });
}


export const queryGifferList = (kuaidiId) => {
    return jwtServerInstance.request({
        url:'/b2cexpressmsg/querygifferlist',
        method:'post',
        data:qs.stringify({
            kuaidiId:kuaidiId
        })
    });
}

export const queryCangList = (cangId) => {
    return jwtServerInstance.request({
        url:'/b2cexpressmsg/querycangist',
        method:'post',
        data:qs.stringify({
            cangId:cangId
        })
    });
}

export const getAllExpress = (pageInfo) =>{
    return jwtServerInstance.request({
        url:'/b2cexpressmsg/all',
        method:'post',
        data:qs.stringify(pageInfo),
    });
}

export const getAllListExpress = () =>{
    return jwtServerInstance.request({
        url:'/b2cexpressmsg/allList',
        method:'post'
    });
}


export const getUserListExpress = () =>{
    return jwtServerInstance.request({
        url:'/b2cexpressmsg/expresslist',
        method:'post'
    });
}

export const addExpress = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cexpressmsg/add',
        method:'post',
        data:dialogForm
    })
}

export  const updateExpress = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cexpressmsg/update',
        method:'post',
        data:dialogForm
    })
}

//删除一条sys_user数据记录
export const deleteExpress = (id) => {
    return jwtServerInstance.request({
        url:'/b2cexpressmsg/deleted',
        method:'post',
        data:qs.stringify({
            id:id
        })
    })
}

//参数配置列表查询接口
export const getExpressUserManageList = (queryForm, pagination) => {
        return jwtServerInstance.request({
            url:'/b2cexpressuser/query',
            method:'post',
            data:qs.stringify({
                id:queryForm.id,
                b2cExpressManageId:queryForm.b2cExpressManageId,
                pageNum: pagination.pageNum,
                pageSize: pagination.pageSize
            })
        })
    }

//参数配置列表查询接口
export const getExpressUserManageAll = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2cexpressuser/all',
        method:'post',
        data:qs.stringify({
            userName: queryForm.userName,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

//更新shopaddress的一条数据记录
export const updateExpressUserManage = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cexpressuser/update',
        method:'post',
        data:dialogForm
    })
}

//新增一条shopaddress数据记录
export const addExpressUserManage = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cexpressuser/add',
        method:'post',
        data:dialogForm
    })
}

//删除一条shopaddress数据记录
export const deleteExpressUserManage = (deleteId) => {
    return jwtServerInstance.request({
        url:'/b2cexpressuser/delete',
        method:'post',
        data:qs.stringify({
            id:deleteId
        })
    })
}
